import { Controller } from '@hotwired/stimulus'
import t from '../functions/t'

export default class extends Controller {
  static targets = ['form', 'currentHandlingPublicInput', 'handlingPublicInput']

  submit() {
    const selectedOption = this.handlingPublicInputTargets.find(
      (radio) => radio.checked
    )

    if (
      selectedOption &&
      selectedOption.value !== this.currentHandlingPublicInputTarget.value
    ) {
      bootbox.confirm({
        message: t('warnings.change_preference'),
        callback: (confirmed) => {
          if (confirmed) {
            this.formTarget.submit()
          }
        },
      })
    } else {
      this.formTarget.submit()
    }
  }
}
